import React from 'react'

interface Props {}

const Return = (props: Props) => {
  return (
    <div>Return</div>
  )
}

export default Return